import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './app/App';
import './app/app.css';
import initApp from './main/initializers/app';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LoaderProvider } from './main/utils/LoaderContext';
import Loader from './main/components/loader/Loader';
import { AppThemeProvider } from './main/theme/AppThemeContext';
import { registerServiceWorker } from './main/pwa/registerServiceWorker';

registerServiceWorker();

initApp().then((appStore: any) => {
  ReactDOM.render(
    <React.StrictMode>
      <Suspense fallback={<Loader forceVisible companyName="Loading" />}>
        <Provider store={appStore}>
          <AppThemeProvider>
            <LoaderProvider>
              <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
              <App />
            </LoaderProvider>
          </AppThemeProvider>
        </Provider>
      </Suspense>
    </React.StrictMode>,
    document.getElementById('root')
  );
});
